import { SITE } from "~/marketing/data/site";
import { cn } from "~/marketing/lib/utils";

interface CTAButtonProps {
  variant?: "primary" | "secondary";
  size?: "default" | "large";
  text?: string;
  href?: string;
  className?: string;
}

export function CTAButton({
  variant = "primary",
  size = "default",
  text,
  href,
  className,
}: CTAButtonProps) {
  const displayText =
    text ?? (SITE.waitlistMode ? SITE.foundingMember.ctaText : "Install Free on Shopify");
  const displayHref =
    href ?? (SITE.waitlistMode ? "#waitlist" : SITE.appInstallUrl);

  const isExternal = !SITE.waitlistMode && !displayHref.startsWith("#");

  return (
    <a
      href={displayHref}
      target={isExternal ? "_blank" : undefined}
      rel={isExternal ? "noopener noreferrer" : undefined}
      className={cn(
        variant === "primary" && "ss-btn-primary",
        variant === "secondary" && "ss-btn-ghost",
        size === "default" && "px-6 py-3 text-sm",
        size === "large" && "px-8 py-4 text-base",
        className
      )}
    >
      {displayText}
    </a>
  );
}
